var map = {
	"./add-photo-fifth-icon-male.svg": "46ea",
	"./add-photo-fifth-icon.svg": "a36bc",
	"./add-photo-first-icon-male.svg": "7328e",
	"./add-photo-first-icon.svg": "952e",
	"./add-photo-fourth-icon-male.svg": "3b16",
	"./add-photo-fourth-icon.svg": "cd3b",
	"./add-photo-second-icon-male.svg": "11aa",
	"./add-photo-second-icon.svg": "291c",
	"./add-photo-sixth-icon-male.svg": "a971",
	"./add-photo-sixth-icon.svg": "a3ec",
	"./add-photo-third-icon-male.svg": "3dd5",
	"./add-photo-third-icon.svg": "1df0",
	"./add-photo.svg": "3f6c",
	"./alert-icon.svg": "d4f8",
	"./amazon-icon.svg": "8ebf",
	"./arrow-down-icon.svg": "b1d4",
	"./arrow-long-left.svg": "a8b8",
	"./basket-icon-orange.svg": "6069",
	"./basket-icon.svg": "cf3a",
	"./bell-icon.svg": "4433",
	"./camera.svg": "c5fc",
	"./cancelled-order-icon.svg": "aad7",
	"./check-blue.svg": "d694",
	"./check-gray.svg": "b9ab",
	"./check-green.svg": "04cd",
	"./check-white.svg": "d2d3",
	"./check.svg": "0b93",
	"./chemicals-icon.svg": "9355",
	"./clipboard-grey-icon.svg": "a610",
	"./clipboard-icon.svg": "9c77",
	"./clocks-icon.svg": "efc4",
	"./close-icon.svg": "1078",
	"./comment-icon.svg": "56a8",
	"./compare-arrow.svg": "a472",
	"./copy-grey-icon.svg": "ef37",
	"./copy-icon.svg": "7ebc",
	"./created-by-user-icon.svg": "8665",
	"./credit-cards.svg": "552a",
	"./cross.svg": "716e",
	"./dashboard-icon-orange.svg": "7107",
	"./dashboard-icon.svg": "ece5",
	"./default-diagnostics-tab-icon.svg": "8c96",
	"./down.svg": "5ed8",
	"./dropdown-arrow-down.svg": "8fd7",
	"./dropdown-icon-down.svg": "2acf",
	"./email-orange.svg": "e9bb",
	"./email.svg": "7c1c",
	"./empty-comments.svg": "b234",
	"./empty-photo.svg": "a714",
	"./exclamation-mark-green-icon.svg": "e843",
	"./exclamation-mark-icon.svg": "f66a",
	"./external-link-icon.svg": "10bcd",
	"./facebook-orange.svg": "9357",
	"./facebook.svg": "fa05",
	"./filter-applied.svg": "49db",
	"./filter.svg": "7b72",
	"./flag-checkered-solid-orange.svg": "d910",
	"./flag-checkered-solid.svg": "bd0b",
	"./free-products-icon.svg": "1800",
	"./glossary-icon-orange.svg": "31ea",
	"./glossary-icon.svg": "7f8c7",
	"./go-to-icon.svg": "3c82",
	"./green-check-bold-icon.svg": "1717",
	"./help-circle-white.svg": "9dbe",
	"./help-icon.svg": "70ce",
	"./hourglass-end-solid.svg": "dc89",
	"./inactive-icon.svg": "1580",
	"./influencer-icon.svg": "eed3",
	"./info-icon.svg": "2cc7b",
	"./invited-by-influencer-icon.svg": "bebc",
	"./invited-by-user-icon.svg": "5663",
	"./inviting-patients-icon-orange.svg": "6593",
	"./inviting-patients-icon.svg": "b3d5",
	"./iphone.svg": "58e6",
	"./language-icon.svg": "7884",
	"./log-out-icon.svg": "3329",
	"./logo.svg": "abb2",
	"./loyalty-program-article-icon-orange.svg": "ee73",
	"./loyalty-program-article-icon.svg": "b321",
	"./loyalty-program-icon.svg": "1a1c",
	"./marketing-speaker-icon.svg": "fc76",
	"./message-templates-icon-orange.svg": "9564",
	"./message-templates-icon.svg": "a5dd",
	"./microneedling/microneedling-circle-active.svg": "79fc",
	"./microneedling/microneedling-circle-fill.svg": "5b41",
	"./microneedling/microneedling-circle.svg": "b710",
	"./microneedling/microneedling-user-guide-orange.svg": "2cae",
	"./microneedling/microneedling-user-guide.svg": "7dae",
	"./microneedling/microneedling.svg": "34b8",
	"./minus-icon-gray.svg": "0039",
	"./new-bell-icon.svg": "3ef3",
	"./notifications-icon-orange.svg": "c84b",
	"./notifications-icon.svg": "385e",
	"./offer-sent-icon.svg": "c43a",
	"./orange-pencil-icon.svg": "2c34",
	"./patient-icon.svg": "0d58",
	"./patients-icon-orange.svg": "8342",
	"./patients-icon.svg": "4c43",
	"./pdf-file.svg": "ab7c",
	"./pencil-icon.svg": "7a1a",
	"./person-icon-orange.svg": "d36b",
	"./person-icon.svg": "c739",
	"./personalize-packaging-no-matсhing.svg": "0a60",
	"./personalize-packaging.svg": "d7f3",
	"./phone-right-icon-orange.svg": "ebb0",
	"./phone-right-icon.svg": "1cb6",
	"./photo-analysis-article-icon-orange.svg": "bc81",
	"./photo-analysis-article-icon.svg": "ab2f",
	"./photo-analysis-icon.svg": "641b",
	"./plus-active-icon.svg": "5a06",
	"./plus-icon-gray.svg": "cdd1",
	"./plus-icon-white.svg": "f0da",
	"./portrait-icon.svg": "ca3f",
	"./price-settings-icon-orange.svg": "f614",
	"./price-settings-icon.svg": "2ada",
	"./question.svg": "163f1",
	"./questionnaire-icon-orange.svg": "533a",
	"./questionnaire-icon.svg": "0f86",
	"./quick-label-print-icon-orange.svg": "69ae",
	"./quick-label-print-icon.svg": "e626",
	"./quick-treatment-icon.svg": "ec63",
	"./red-cross-bold-icon.svg": "2d59",
	"./replicate-treatment-icon.svg": "9186",
	"./search-active-icon.svg": "dccd",
	"./search.svg": "2175",
	"./shield-check.svg": "80cb",
	"./shield-disable.svg": "a07c",
	"./skin-diagnostic-icon-orange.svg": "cdad",
	"./skin-diagnostic-icon.svg": "56f7",
	"./skinxs-black-icon.svg": "434d",
	"./skinxs-gray-icon.svg": "c92f",
	"./skinxs-icon.svg": "7a67",
	"./skinxs-logo-large.svg": "2989",
	"./skinxs-logo-medium.svg": "a45d",
	"./skinxs-logo-small-black.svg": "eb84",
	"./skinxs-logo-small.svg": "b45e",
	"./skinxs-orange-icon.svg": "2211",
	"./sms-orange.svg": "9add",
	"./sms.svg": "a13b",
	"./speaker-icon.svg": "83c0",
	"./stopwatch-solid-icon.svg": "4dd1",
	"./test-meter-icon.svg": "d56f",
	"./treatment-history-tab-icon.svg": "05ee",
	"./treatment-icon-orange.svg": "fbec",
	"./treatment-icon.svg": "6ead",
	"./treatment-with-questionnaire-icon.svg": "8f2b",
	"./treatment-with-treatment-directory-icon.svg": "fe16",
	"./treatments-directory-icon-orange.svg": "f031",
	"./treatments-directory-icon.svg": "e381",
	"./treatments/can-not-be-used-ingredients-icon.svg": "aa3e",
	"./treatments/copy-serum-active-icon.svg": "3cb7",
	"./treatments/copy-serum-icon.svg": "5355",
	"./treatments/empty-photo-icon.svg": "ed71",
	"./treatments/evening-usage-active-icon.svg": "9fbf",
	"./treatments/evening-usage-icon.svg": "0d94",
	"./treatments/highly-recommended-ingredients-icon.svg": "6431b",
	"./treatments/morning-and-evening-usage-active-icon.svg": "5db4",
	"./treatments/morning-and-evening-usage-icon.svg": "11fc",
	"./treatments/morning-usage-active-icon.svg": "409a",
	"./treatments/morning-usage-icon.svg": "6088",
	"./treatments/nexultra-active-icon.svg": "5be8",
	"./treatments/nexultra-b-active-icon.svg": "ef5c",
	"./treatments/nexultra-b-icon.svg": "fcfe",
	"./treatments/nexultra-icon.svg": "b6501",
	"./treatments/nexultra-l-brush-active-icon.svg": "a90d",
	"./treatments/nexultra-l-brush-icon.svg": "a75a",
	"./treatments/nexultra-p-active-icon.svg": "06b7",
	"./treatments/nexultra-p-icon.svg": "4baa",
	"./treatments/nexultra-sunscreen-active-icon.svg": "bdc1",
	"./treatments/nexultra-sunscreen-icon.svg": "b5af",
	"./treatments/nexultra-uv-active-icon.svg": "83ec",
	"./treatments/nexultra-uv-icon.svg": "4dfb",
	"./treatments/recalculate-icon.svg": "9cc0",
	"./treatments/recommended-ingredients-icon.svg": "d9d3",
	"./treatments/universkin-h-active-icon.svg": "f472",
	"./treatments/universkin-h-icon.svg": "71aa",
	"./treatments/universkin-m-active-icon.svg": "0269",
	"./treatments/universkin-m-icon.svg": "126e",
	"./treatments/universkin-o-active-icon.svg": "625d",
	"./treatments/universkin-o-icon.svg": "6168",
	"./treatments/universkin-serum-p-active-icon.svg": "453b",
	"./treatments/universkin-serum-p-icon.svg": "91ea",
	"./under-preparation-icon.svg": "86a2",
	"./upload-icon-white.svg": "1461",
	"./upload-icon.svg": "6f51",
	"./user-icon.svg": "efa3",
	"./vertical-dots-icon.svg": "2a098",
	"./web-developer.svg": "4018",
	"./webcamera-icon-white.svg": "bd82",
	"./webcamera-icon.svg": "7f5d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6089";